import axiosInstance from './axios';
import { Department, DepartmentNode, DepartmentStatus } from '../../types';

export interface CreateDepartmentDto {
  code: string;
  name: string;
  parentId?: number | null;
  headEmployeeId?: number | null;
  status?: DepartmentStatus;
}

export interface UpdateDepartmentDto {
  name?: string;
  parentId?: number | null;
  headEmployeeId?: number | null;
  status?: DepartmentStatus;
}

export interface DepartmentDetail {
  department: Department;
  children: Department[];
  employees: any[];
}

class DepartmentsService {
  private basePath = '/departments';

  /**
   * Get all departments (flat list)
   */
  async getAll(): Promise<Department[]> {
    const response = await axiosInstance.get<Department[]>(this.basePath);
    return response.data;
  }

  /**
   * Get all departments as tree structure
   */
  async getTree(): Promise<DepartmentNode[]> {
    const response = await axiosInstance.get<DepartmentNode[]>(this.basePath, {
      params: { tree: 'true' },
    });
    return response.data;
  }

  /**
   * Get department by ID with details (children, employees)
   */
  async getById(id: number): Promise<DepartmentDetail> {
    const response = await axiosInstance.get<DepartmentDetail>(`${this.basePath}/${id}`);
    return response.data;
  }

  /**
   * Create a new department
   */
  async create(data: CreateDepartmentDto): Promise<Department> {
    const response = await axiosInstance.post<Department>(this.basePath, data);
    return response.data;
  }

  /**
   * Update a department
   */
  async update(id: number, data: UpdateDepartmentDto): Promise<Department> {
    const response = await axiosInstance.patch<Department>(`${this.basePath}/${id}`, data);
    return response.data;
  }

  /**
   * Delete a department
   */
  async delete(id: number): Promise<void> {
    await axiosInstance.delete(`${this.basePath}/${id}`);
  }
}

export const departmentsService = new DepartmentsService();
